const env = process.env.HOST_VARIABLE || 'development';

const devConfig = {
  BASE_URL_AUTH: 'https://apidev.teleperson.com/',
  BASE_URL_AUTH_DONE: 'https://apidev.teleperson.com/',
  CHATBOT_URL: 'https://jessica-development.vercel.app',
  CHATBOT_API_URL: 'https://jessica-development.vercel.app/api/chatbot',
};

const prodConfig = {
  BASE_URL_AUTH: 'https://api.teleperson.com/',
  BASE_URL_AUTH_DONE: 'https://api.teleperson.com/',
  CHATBOT_URL: 'https://jessica.teleperson.com',
  CHATBOT_API_URL: 'https://jessica.teleperson.com/api/chatbot',
};

const configs = {
  development: devConfig,
  production: prodConfig,
};

export default configs[env];
